export default __webpack_public_path__ + "static/media/img4.88a2ee67.jpg";